import React from 'react';
import { Plane, Hotel, ShieldCheck, Languages } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

export default function WhyUsSection() {
  const { t } = useLanguage();
  const cards = [
    { Icon: Plane, key: 'transfer' },
    { Icon: Hotel, key: 'hotel' },
    { Icon: ShieldCheck, key: 'warranty' },
    { Icon: Languages, key: 'team' },
  ];

  return (
    <section id="why-us" className="section-padding section-tone-b">
      <div className="container-premium">
        <div className="section-head">
          <span className="section-eyebrow">{t('whyUs.eyebrow', 'Why Crystal Dental')}</span>
          <h2 className="section-title">{t('whyUs.title', 'Premium Care, Premium Experience')}</h2>
          <p className="section-sub">{t('whyUs.subtitle', 'Every patient is treated like family — from the moment you land to your final follow-up.')}</p>
        </div>

        <div className="why-grid">
          {cards.map(({ Icon, key }) => (
            <article key={key} className="why-card">
              <div className="why-icon">
                <Icon size={22} />
              </div>
              <h3>{t(`whyUs.${key}.title`, '')}</h3>
              <p>{t(`whyUs.${key}.description`, '')}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
